import { TextField, MenuItem, TextFieldProps } from '@mui/material';
import { FormikProps } from 'formik';

interface SelectOption {
  value: string | number | boolean;
  label: string;
}

interface SelectFieldProps extends Omit<TextFieldProps, 'name' | 'select'> {
  name: string;
  formik: FormikProps<any>;
  options: SelectOption[];
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

export default function SelectField({ formik, name, options, onChange, ...props }: SelectFieldProps) {
  const error = formik.touched[name] && Boolean(formik.errors[name]);
  const helperText = formik.touched[name] && formik.errors[name];

  return (
    <TextField
      fullWidth
      select
      size="small"
      {...props}
      name={name}
      value={formik.values[name]}
      onChange={onChange ?? formik.handleChange}
      onBlur={formik.handleBlur}
      error={error}
      helperText={helperText as string}
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: '10px',
          '&:hover fieldset': {
            borderColor: '#667eea',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#667eea',
          },
        },
        '& .MuiInputLabel-root.Mui-focused': {
          color: '#667eea',
        },
        mt: 0,
        mb: 0,
        ...props.sx,
      }}
    >
      {options.map((option) => (
        <MenuItem key={String(option.value)} value={String(option.value)}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
